storefrontApp.service("shippingService", [
"$http",
function (
    $http
) {
    return {
        getCountries: function () {
            return $http.get('storefrontapi/countries');
        },
        getCart: function (){
            return $http.get('storefrontapi/cart');
        },
        getShippingInformation: function (address){
            return $http.post('storefrontapi/shipping/productshippinginformation', address);
        },
        getShippingFormats: function (){
            return $http.get("storefrontapi/shipping/formats");
        },
        getShipACDRates: function (){
            return $http.get("storefrontapi/shipping/shipacdrates");
        },
        addOrUpdateMultipleCartShipments: function (shipments){
            return $http.post('storefrontapi/cart/multipleshipments', shipments);
        },
        updateShippingMethod: function (shipACD) {
            return $http.post("storefrontapi/shipping/preferredmethod", shipACD);
        }
    }
}]);
